import { useQuery } from '@tanstack/react-query';
import { useAskBluejApiContext } from '../../api/context';

export function useConfigQuery() {
  const { api } = useAskBluejApiContext();

  return useQuery({
    queryKey: ['config'],
    queryFn: async () => {
      return api.getConfig();
    },
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
}
